import { FunctionComponent } from "react";
import { getActiveSite } from "../../selectors/sites.js";
import { useAppSelector } from "../../store/hooks.js";
import {
  BaseModuleProps,
  ButtonModuleSettings,
  ColorScheme,
} from "../../types/index.js";
import { resolveButtonLink } from "../../utils/utils.js";
import Button from "../Button.js";

type Props = Pick<
  BaseModuleProps<ButtonModuleSettings>,
  "translatedModule" | "isPreview"
> & { scheme: ColorScheme; className?: string };

const ButtonModule: FunctionComponent<Props> = ({
  translatedModule: { settings, translation },
  translatedModule,
  isPreview,
  scheme,
  className,
}) => {
  const site = useAppSelector((state) => getActiveSite(state.sites));
  const pages = useAppSelector((state) => state.pages);
  const anchorAttrs = resolveButtonLink({
    pages,
    isPreview,
    site,
    translatedModule,
  });

  if (!translation.exists) return null;

  return (
    <Button
      className={className}
      scheme={scheme}
      isPreview={isPreview}
      {...settings}
      anchorAttrs={anchorAttrs}
    >
      {translation.settings.title}
    </Button>
  );
};

export default ButtonModule;
